import { useQuery } from "@/api/utils/useQuery"
import { QueryResult } from "@/api/utils/types"
import { BackofficeRestQueries } from "@/api/backofficeRest/queries"
import { RtsStatus } from "@/api/backofficeRest/generated/model"

export interface IRtsStatusService {
  hasRtsMetersByCoreId(coreId: number): QueryResult<boolean>
}

class RtsStatusServiceClass implements IRtsStatusService {
  hasRtsMetersByCoreId(coreId: number): QueryResult<boolean> {
    return useQuery<RtsStatus, boolean>({
      ...BackofficeRestQueries.account.rtsStatus(coreId),
      placeholderData: false,
      useRawResponse: true,
      parserFn: (data) => data?.hasRtsMeters ?? false,
      enabled: !!coreId,
    })
  }
}

export const RtsStatusService = new RtsStatusServiceClass()
